<template>
  <v-dialog 
    v-model="dialog" 
    max-width="450px"
  >
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Separation"
      text="Employee Separation"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row no-gutters>
          <v-col cols="12">
            <v-autocomplete
              v-model="form.separation_type_id"
              v-validate="'required'"
              :items="types"          
              :error-messages="errors.collect('separation_type_id')"
              data-vv-name="separation_type_id"        
              data-vv-as="separation type"
              label="Types"
              placeholder="Separation Types"              
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
            />
          </v-col>
          
          <v-col cols="12">
            <v-menu
              v-model="lastWorkingDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="form.last_working_date"
                  v-validate="'required'"
                  :error-messages="errors.collect('last_working_date')"
                  data-vv-name="last_working_date"  
                  data-vv-as="last working date"      
                  label="Last Working Date"
                  readonly
                  v-on="on"
                />
              </template>

              <v-date-picker
                v-model="form.last_working_date"                
                @input="lastWorkingDateMenu = false"
              />
            </v-menu>
          </v-col>

          <v-col cols="12">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="form.effective_date"
                  v-validate="'required'"
                  :error-messages="errors.collect('effective_date')"
                  data-vv-name="effective_date"  
                  data-vv-as="effective date"      
                  label="Effective date"
                  readonly
                  v-on="on"
                />
              </template>

              <v-date-picker
                v-model="form.effective_date"                
                @input="menu = false"
              />
            </v-menu>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="form.reason"
              v-validate="'required|max:5000'"
              :rows="5"
              :error-messages="errors.collect('reason')"
              data-vv-name="reason"        
              label="Reason"
            />
          </v-col>   
          <v-col cols="12">
            <helper-file-input
              v-model="file" 
              :max-size-in-mb="2"
              :max-number="5"
              :multiple="true"
              data-vv-name="files"
              field-name="files"
              accept-type=".pdf"     
              extension="ext:pdf"        
            >
              <div 
                slot="activator"
                class="mb-2"
              >   
                <v-btn                    
                  :disabled="progressing"
                  class="mx-2"    
                >
                  Add file
                </v-btn>
                <span> 
                  {{ file ? '' : 'No file chosen (.pdf only)' }}
                </span>
                <div
                  v-if="file"
                  class="mt-4"
                >
                  <p
                    v-for="selectedFile in file.selectedFiles"
                    :key="selectedFile.name"
                    class="mb-0"
                  >
                    <span class="font-weight-bold">{{ selectedFile.name }}</span>
                  </p>
                </div>
              </div>
            </helper-file-input>
            <span class="red--text text--lighten-1">{{ errors.first('files') }}</span>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer />
        <v-btn 
          text
          @click="dialog = false"
        >
          close
        </v-btn>
        <v-btn 
          :loading="progressing"
          color="success" 
          dark 
          @click="submitForm"
        >
          Resign
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      HelperFileInput: () => import('@/components/helper/FileInput'),
    },
    inject: ['$validator'],
    props: {
      employeeUid: {
        type: String,
        default: '',
      },    
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        loading: false,
        menu: false,
        lastWorkingDateMenu: false,
        types: [],
        file: null,
        form: {
          separation_type_id: null,
          effective_date: '',
          reason: '',
          last_working_date: '',
        },
      }
    },
    watch: {
      dialog: function (val) {
        if (val) {
          this.loadTypes()
        } else {
          this.$resetData()
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll().then(result => {
          if (!result) return
          
          this.progressing = true

          this.$api.employeeSeparations().create(this.employeeUid, this.prepareFormData())
            .then(response => {
              if (response.status >= 200 && response.status < 300) {
                this.$emit('created')
                this.$snack({ message: 'Employee resigned' })

                this.dialog = false
              }
            })
            .catch(error => {
              if (error.response.status === 405) {
                this.$dialog({
                  title: 'Unable to resign',
                  message: error.response.data.status,
                  color: 'error',
                })
                // this.$snack({ 
                //   color: 'error',
                //   message: error.response.data.status, 
                // })
              }
            })
            .then(() => {
              this.progressing = false
            })
        })
      },
      openDialog () {
        this.dialog = true
      },
      loadTypes () {
        this.loading = true 

        this.$api.separationTypes().list().then(response => {
          this.types = response.data

          this.loading = false
        })
      },
      prepareFormData () {
        if (this.file) {
          this.file.formData.set('separation_type_id', this.form.separation_type_id)
          this.file.formData.set('reason', this.form.reason)
          this.file.formData.set('effective_date', this.form.effective_date)
          this.file.formData.set('last_working_date', this.form.last_working_date)

          return this.file.formData
        }

        let formData = new FormData()

        formData.append('separation_type_id', this.form.separation_type_id)
        formData.append('reason', this.form.reason)
        formData.append('effective_date', this.form.effective_date)
        formData.append('last_working_date', this.form.last_working_date)

        return formData
      },
    },
  }
</script>
